import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from '../../components/Skeleton/Skeleton';
import {REQUEST_FORMS_DATA} from "../../actions/formsActions";
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";
import ContentRenderer from "../../components/ContentRenderer/ContentRenderer";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import store from "../../store";
import {Helmet} from "react-helmet";

const mapStateToProps = state => {
  return {
    formsData: state.formsData
  }
};

const mapDispatchToProps = dispatch => ({
  getFormsData: () => dispatch({type: REQUEST_FORMS_DATA})
});

class FileAClaim extends Component {

  componentDidMount() {
    if (!this.props.formsData.forms) {
      this.props.getFormsData();
    }
  };

  render() {
    return (
      <div className="wrapper mbl pbm">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Manage" ? row.sections.map((section) => {
                          return section.title === "File a Claim" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/manage/page-components/text-block/file-a-claim-heading.html"
        />
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/manage/page-components/content-detail/file-a-claim-body-1.html"
        />

        {this.props.formsData.forms ?
          <ul className="unstyled-list">
            {
              this.props.formsData.forms
              .filter((item) => {
                return item.linkedPages.indexOf('/file-a-claim') > -1
              })
              .map((item, index) => {

                const formTitle = item.title.replace(/[F|f]orm/g, '');

                return (
                  <li key={index} className="mtl ptl">
                    <h2 className="forms-and-applications__title">{formTitle}</h2>
                    <div className="fg">
                      <div className="fg__col-lg-8 fg__col-md-12 fg__col-sm-12">
                        {
                          (item.content && item.content.type && item.content.value) ?
                            <ContentRenderer
                              contentType={item.content.type}
                              value={item.content.value}
                              skeletonType="MAIN_PANEL"
                            /> : null
                        }
                      </div>
                      <div className="fg__col-lg-4 fg__col-md-12 fg__col-sm-12">
                        <NavLink to={this.props.formsData.formUrls[item.formReferenceName]} className="cta-transparent forms-and-applications__button">{formTitle}</NavLink>
                      </div>
                    </div>
                  </li>
                )
              })
            }
          </ul>
          : null
        }
      </div>
    )
  };
}

export default (connect(mapStateToProps, mapDispatchToProps)(FileAClaim));



// WEBPACK FOOTER //
// ./src/pages/manage/FileAClaim.js